module.exports = __webpack_public_path__ + "media/msg.3ecd1afc.mp3";